module.exports = __webpack_public_path__ + "img/IMG_9696.7ece01bb.jpeg";